import { RemoveScrollBar } from './component';
import { zeroRightClassName, fullWidthClassName, noScrollbarsClassName, removedBarSizeVariable } from './constants';
import { getGapWidth } from './utils';
export { RemoveScrollBar, zeroRightClassName, fullWidthClassName, noScrollbarsClassName, removedBarSizeVariable, getGapWidth, };



//////////////////
// WEBPACK FOOTER
// ./~/react-remove-scroll-bar/dist/es2015/index.js
// module id = 9046
// module chunks = 2